import { TextareaHTMLAttributes, useRef } from 'react';

import { Label } from '../Label/Label';

export const TextArea = ({
  errorMessage,
  id,
  maxLength,
  label,
  value,
  onChange,
  length,
  ...props
}: {
  errorMessage?: string;
  id?: string | number;
  label?: string;
  maxLength?: number;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  length?: number;
} & TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const textValue = value || '';
  const isLonger = maxLength && maxLength < textValue.length;
  const currentLength = maxLength ? maxLength - textValue.length : undefined;

  return (
    <div className={'flex flex-col gap-[16px]'}>
      <Label id={id} label={label} required={props.required} />
      <div className={'flex flex-col gap-[8px]'}>
        <div className={'relative h-[168px]'}>
          <textarea
            data-testid={'textarea'}
            value={textValue}
            ref={ref}
            onChange={onChange}
            className={`hZ-[168px] w-full resize-none rounded-[16px] border-[1px] ${
              isLonger ? 'border-red500' : 'border-gray200'
            } overflow-y-scroll p-[24px] text-[20px] leading-[30px] focus:outline-0 active:outline-0`}
            name={id?.toString()}
            id={id?.toString()}
            cols={30}
            rows={4}
            {...props}
          ></textarea>
          {maxLength !== undefined && currentLength !== undefined && (
            <div
              className={`absolute bottom-[18px] right-[22px] text-[14px] leading-[20px] ${
                isLonger ? 'text-red500' : 'text-gray-300'
              }`}
            >
              {currentLength}
            </div>
          )}
        </div>
        {(errorMessage && isLonger) ||
          (errorMessage && !maxLength && (
            <label
              onClick={() => ref?.current?.focus()}
              htmlFor={id?.toString()}
              className={'text-[16px] leading-[22px] text-red500'}
            >
              {errorMessage}
            </label>
          ))}
      </div>
    </div>
  );
};
